<div class="container" role="main">
  <div class="HmsContainer">
    <div class="row">
      <div class="row HmsInsideContainer">
        <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"></div>

        <div class="col-xs-12 col-sm-12 col-md-11 col-lg-11">
          <form class="finalForm" [formGroup]="finalForm">
            <div class="confirmation-box" style="border: 2px solid var(--primary-color); padding: 10px; border-radius: 15px;">
              <p role="heading" aria-level="1" style="font-weight: bold;">
                Your referral was successfully submitted. Please document your reference ID number.
              </p>
              <p style="font-weight: bold;">
                Reference ID #: <span>{{ referenceId }}</span>
              </p>
            </div>
            <div class="mt-3" [innerHtml]="confirmationmsg"></div>
            <p class="mt-2"> You may close this browser or hit the ‘Enter New Referral’ button to start a new referral.</p>
            <div class="col-md-10 mt-3">
              <button type="button" class="btn orangeBtn" (click)="finalDetailsSubmit()" [ngStyle]="{ 'background-color': primaryColor }"> Enter New Referral </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
